import {
  StepDescription,
  StepTitle,
} from '@eliadmin/core/src/components/dlz/auth/password-reset/step-heading';
import { ActionLink } from '@eliadmin/core/src/components/dlz/auth/password-reset/action-link';
import { RESET_COPY } from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-copy';
import { useAuthNavigation } from '@eliadmin/core/src/components/dlz/auth/dialog/auth-navigation';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

/**
 * Step 4 – „Heslo bolo zmenené“ (Figma 60158:21486, mobile 60438:82686). The design has no
 * stepper here and reuses the compact success card of the review dialog.
 */
export function DoneStep({ loggedOutOtherDevices }: { loggedOutOtherDevices: boolean }) {
  const { showLogin } = useAuthNavigation();

  return (
    <>
      <Icon name="check-circle" size={52} className="text-[#22A04B]" />
      <div className="flex w-full flex-col gap-3">
        <StepTitle size="h2" focusTarget>
          {RESET_COPY.done.title}
        </StepTitle>
        <StepDescription>
          {loggedOutOtherDevices ? RESET_COPY.done.text : RESET_COPY.done.textKeptDevices}
        </StepDescription>
      </div>
      <Button type="button" onClick={showLogin} className="h-12 w-full md:h-[52px] md:w-auto">
        {RESET_COPY.done.signIn}
      </Button>
      <ActionLink href={ROUTES.HOME()}>{RESET_COPY.done.continueShopping}</ActionLink>
    </>
  );
}
